import React from "react";
import { createStyles, Dialog, Divider, IconButton, makeStyles, Grid, Checkbox, Typography, CircularProgress, RadioGroup, FormControlLabel, Radio } from "@material-ui/core";
import {
    //DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Popover from "@material-ui/core/Popover";
import moment from "moment";
import "react-dates/initialize";
//import { DateRangePicker } from "react-dates";
import ReactDatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import "react-dates/lib/css/_datepicker.css";
import ItemPopover from "./ItemPopover";
import { useTranslation } from "react-i18next";
import "moment/locale/fr";
//import { SearchLocation } from "./SearchLocation";
import home_2 from "../../images/home_2.jpg";
//import { PropertyService } from "../Properties/services/PropertyService";
import { colors } from "../../styles/defaultColors";
import { useHistory } from "react-router-dom";
import { PnbPlaceSelector } from "../components/PnbPlaceSelector";
import SearchIcon from '@mui/icons-material/Search';
import clsx from 'clsx';
import { ESearchErrorMessages } from "../../utils/enum/properties";
import { useQuery } from "../../utils/App";
import { CurrencyContext } from "../../contexts/AppContext";
import { useContext } from 'react';
//import { CountryPhoneList } from "../../utils/CountryList";
import { SearchPrice } from "./SearchPrice";
import { CountryService } from "../Admin/Countries/services/EquipmentCountry";
import { IVille } from "../../utils/DiversInterfaces";
import { IPays } from "../../utils/DiversInterfaces";
//import { FocusedInputShape } from "react-dates";
import { PnbPlaceCitySelector } from "../components/PnbPlaceCitySelector";
import { PnbPlaceQuartierSelector } from "../components/PnbPlaceQuartierSelector";
import { useLocation } from 'react-router-dom';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const useStyles = makeStyles((theme) =>
    createStyles({
        heroContainer: {
            backgroundImage: `url(${home_2})`,
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: "center",
            position: "relative"
        },
        home: {
            width: '100%',
            minHeight: "100%",
            position: "relative",
            top: "-100px !important"
        },
        cover: {
            width: '100%',
            height: "100vh",
            position: "absolute",
            background: "rgba(0, 0, 0, 0.2)",
        },

        // Search Components
        searchContainer: { 
            marginTop: "15px",
            paddingTop: "10px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            border: "1px solid #DDDDDD !important",
            alignItems: "center",
            position: "relative",
            width: "100%",
            maxWidth: 800,
            height: "auto",
            background: "#ffffff",
            color: "#222222 !important",
            outline: "none !important",
            boxShadow: "0px 16px 32px rgb(0 0 0 / 15%), 0px 3px 8px rgb(0 0 0 / 10%) !important",
            borderRadius: 32,
            [theme.breakpoints.down(1025)]: {
                maxWidth: 1000
            },
            [theme.breakpoints.down("sm")]: {
                top: "30%",
                flexDirection: "column",
                borderRadius: 10,
                paddingBottom: 10,
                height: "auto",
                background: "rgba(255, 255, 255, 0.7)",
                border: "none!important"
            },
            [theme.breakpoints.down("xs")]: {
                top: "15%",
                flexDirection: "column",
                borderRadius: 10,
                maxWidth: 300
            },

            "& > div": {
                marginRight: 8,
                [theme.breakpoints.down("sm")]: {
                    width: "100%",
                    marginRight: 0
                },
                [theme.breakpoints.down("xs")]: {
                    width: "100%",
                    marginRight: 0
                },
            },
        },
        label: {
            cursor: "pointer !important",
            border: "1px solid transparent !important",
            borderRadius: "32px !important",
            padding: "7px 32px 3px 32px !important",
            width: 300,
            transition: "background 0.3s ease", // Add smooth transition
            "&:hover": {
                background: "#e1e1e1"
            },
        },
        labels: {
            fontSize: '13px', // Label font size
            lineHeight: 1, // Tighten line height
        },
        selectedLabel: {
            backgroundClip: "padding-box !important",
            border: "1px solid rgb(255, 255, 255) !important",
            borderRadius: "32px !important",
            backgroundColor: "rgb(255, 255, 255) !important",
            boxShadow: "rgb(0 0 0 / 20%) 0px 6px 20px !important",
            [theme.breakpoints.down("sm")]: {
                borderRadius: "10px !important"
            },
        },
        searchLocation: {
            display: "flex",
            justifyContent: "center",
            width: 344,
            height: 37,
            padding: "9px 15px",
            background: "#FFFFFF",
            border: "1px solid #890608",
            borderRadius: 150,
            marginBottom: theme.spacing(1),
            marginTop: theme.spacing(1),
            [theme.breakpoints.down("sm")]: {
                border: "none",
                borderRadius: 0
            },
            [theme.breakpoints.down("xs")]: {
                border: "none",
                borderRadius: 0
            },
        },
        searchDateContainer: {
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            background: 'transparent',
            '& .separator': {
                margin: '0 8px',
                color: '#000',
                fontSize: '14px',
            },
        },
        searchTraveller: {
            display: "flex",
            alignItems: "center",
            border: 0,
            [theme.breakpoints.down("sm")]: {
                border: "none",
                borderRadius: 0
            },
            [theme.breakpoints.down("xs")]: {
                border: "none",
                borderRadius: 0
            },
        },
        btnTravellerr: {
            fontFamily: "Josefin Sans",
            fontSize: 14,
            opacity: 1,
            textTransform: "capitalize",
            padding: 0,
            "&  p": {
                marginLeft: 5,
                marginTop: 0,
                marginBottom: 0
            },
        },
        popContainer: {
            padding: "16px 32px",
            background: "#ffffff",
            overflowX: "hidden",
            overflowY: "auto",
            fontSize: "11px"
        },
        popItem: {
            minWidth: 286,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingTop: 16,
            paddingRight: 4,
            paddingBottom: 16,
            color: "rgb(34, 34, 34)",

            "&:not(:last-child)": {
                borderBottom: "1px solid rgb(235, 235, 235)",
            },
        },
        popItemLeft: {},
        popItemRight: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: 104,
            height: 32,
            color: "rbg(34,34,34)",
            fontSize: 16,
            fontWeight: 400,
        },
        popTextAdultTitle: {
            fontSize: 16,
            fontWeight: 600,
        },
        popTextAdultSubTitle: {
            fontSize: 11,
            fontWeight: 400,
            color: "rgb(113, 113, 113)",
        },
        popItemIcon: {
            width: 32,
            height: 32,
            cursor: "pointer",
            display: "inline-flex",
            margin: 0,
            padding: 0,
            textAlign: "center",
            border: "1px solid rgb(176, 176, 176)",
            color: "rgb(113, 113, 113)",
            outline: "none",
            alignItems: "center",
            justifyContent: "center",
            background: "rgb(255, 255, 255)",
            borderRadius: "50%",
        },
        popRadiuss: {
            marginTop: 10,
            background: "#ffffff !important",
            borderRadius: "32px !important",
            boxShadow: "0px 6px 20px rgb(0 0 0 / 20%) !important",
            fontSize: "11px"
        },
        ItemNbrpop: {
            color: "#222222",
            fontSize: 16,
        },
        reactDates: {
            width: "100%",
        },
        datePickerContainer: {
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            width: '100%',
            background: 'transparent',
            '& .react-datepicker-wrapper': {
                flex: 1,
            },
            '& .react-datepicker__input-container input': {
                width: '100%',
                background: 'transparent',
                border: 'none',
                fontSize: '14px',
                fontFamily: 'Josefin Sans, sans-serif',
                color: '#000',
                padding: '8px 2px',
                '&::placeholder': {
                    color: '#A0A0A0',
                },
            },
        },
        showErrors: {},
        searchButtonn: {
            padding: 13,
            fontSize: 14,
            color: "white",
            textTransform: "capitalize",
            background: "#890608 !important",
            borderRadius: "50%",
            fontFamily: "Josefin Sans",
            position: "absolute",
            right: 8,
            "&:hover": {
                background: "#B5551B !important",
            },
            [theme.breakpoints.down("sm")]: {
                position: "absolute",
                bottom: -22,
                right: "auto"
            },
        },
        errors: {
            color: colors.danger,
            background: colors.backgroundDanger,
            width: "100%",
            textAlign: "center",
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            borderRadius: 5,
            "& p": {
                padding: 10,
            },
        },
        loading: {
            width: "100%",
            minHeight: "40vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
        formSearch: {
            position: "absolute",
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            [theme.breakpoints.down("sm")]: {
                top: "20%",
            },
            [theme.breakpoints.down("xs")]: {
                top: "20%",
                alignItems: "center"
            },
        },
        feel: {
            color: "#ffffff",
            fontSize: 65,
            width: 446,
            textTransform: "capitalize",
            marginBottom: 70,
            fontWeight: "bold",
            [theme.breakpoints.down("sm")]: {
                marginBottom: 30,
                fontSize: 46
            },
            [theme.breakpoints.down("xs")]: {
                marginBottom: 20,
                fontSize: 30,
                width: 350
            },
        },
        iconRoom: {
            [theme.breakpoints.down("sm")]: {
                display: "none!important"
            },
            [theme.breakpoints.down("xs")]: {
                display: "none!important"
            },
        },
        paper: {
            padding: 20
        },
        formSm: {
            display: "flex",
            width: "100%",
            flexDirection: "column",
            [theme.breakpoints.down("xs")]: {
                display: "none!important"
            },
        },
        formXs: {
            display: "flex",
            width: "100%",
            flexDirection: "column",
            [theme.breakpoints.up("sm")]: {
                display: "none!important"
            },
        },
        mobileForm: {
            display: "flex"
        },
        searchContaine: {
            display: "flex",
            flexDirection: "column",
            background: "#ffffff",
            borderRadius: 10,
            padding: theme.spacing(2),
            boxShadow: "0px 6px 20px rgba(0,0,0,0.15)",
        },
        topRow: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: theme.spacing(2),
            [theme.breakpoints.down('sm')]: {
                flexDirection: 'column',
            },
        },
        secondRow: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: theme.spacing(2),
            [theme.breakpoints.down('sm')]: {
                flexDirection: 'column',
            },
        },
        amenitiesRow: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: theme.spacing(2),
            [theme.breakpoints.down('sm')]: {
                flexDirection: 'column',
            },
        },
        dropdownn: {
            width: "100%",
            padding: theme.spacing(1),
            marginBottom: theme.spacing(2),
            borderRadius: 8,
            border: "1px solid #ddd",
        },
        priceInputContainerr: {
            display: 'flex',
            alignItems: 'center',
            [theme.breakpoints.down('sm')]: {
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: theme.spacing(1),
            },
        },
        priceInputt: {
            width: '80px',
            padding: theme.spacing(1),
            borderRadius: theme.shape.borderRadius,
            border: `1px solid ${theme.palette.grey[400]}`,
            [theme.breakpoints.down('sm')]: {
                width: '100%',
            },
        },
        priceSeparatorr: {
            margin: `0 ${theme.spacing(1)}px`,
        },
        datePickerContainerr: {
            display: "flex",
            gap: theme.spacing(1),
        },
        checkboxx: {
            display: 'flex',
            alignItems: 'center',
        },
        button: {
            background: "#890608",
            color: "#fff",
            padding: theme.spacing(1, 3),
            borderRadius: 12,
            fontSize: "12px",
        },
        priceLabel: {
            display: 'flex',
            alignItems: 'center',
        },
        amenitiesSectionn: {
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)', // 4 columns for large screens
            gap: theme.spacing(3),
            [theme.breakpoints.down("md")]: {
                gridTemplateColumns: 'repeat(2, 1fr)', // 2 columns for tablets
                gridTemplateRows: 'auto auto',
                gap: theme.spacing(2),
            },
            [theme.breakpoints.down("sm")]: {
                gridTemplateColumns: '1fr', // 1 column for mobile
                gap: theme.spacing(1.5),
            },
        },
        sectionHeaderr: {
            fontSize: '14px',
            fontWeight: 'bold',
            color: theme.palette.text.primary,
            marginBottom: theme.spacing(1),
        },
        checkBoxContainerr: {
            display: 'flex',
            alignItems: 'center',
            gap: theme.spacing(1),
            fontSize: '13px',
            '& input': {
                marginRight: theme.spacing(1),
                transform: 'scale(1.2)',
                [theme.breakpoints.down("sm")]: {
                    transform: 'scale(1)',
                },
            },
            '& label': {
                fontWeight: 'normal',
                color: theme.palette.text.secondary,
            },
        },
        dividerr: {
            height: '100%',
            backgroundColor: theme.palette.divider,
            [theme.breakpoints.down("md")]: {
                display: 'none', // Hide divider on medium and small screens
            },
        },
        divider: {
            margin: theme.spacing(1, 0.5), // Minimal margin for vertical divider
        },

        searchContainerr: {
            display: "flex",
            flexDirection: "column",
            background: "#ffffff",
            borderRadius: 16,
            padding: theme.spacing(2),
            boxShadow: "0px 8px 16px rgba(0,0,0,0.15)",
            maxWidth: 1200,
            width: "100%",
            margin: "auto",
            [theme.breakpoints.down("sm")]: {
                padding: theme.spacing(1.5),
            },
        },
        rowContainer: {
            display: "flex",
            flexWrap: "wrap",
            gap: theme.spacing(2),
            marginBottom: theme.spacing(2),
            [theme.breakpoints.down("sm")]: {
                flexDirection: "column",
                marginBottom: theme.spacing(1.5),
            },
        },
        dropdown: {
            flex: 1,
            padding: theme.spacing(1),
            borderRadius: 8,
            border: "1px solid #ddd",
            background: "#f9f9f9",
            fontSize: "0.95rem",
        },
        priceInputContainer: {
            display: 'flex',
            alignItems: 'center', // Vertically centers the contents
            gap: '8px', // Adds space between elements
            justifyContent: 'space-between', // Ensures the elements use space efficiently
        },
        priceInput: {
            flex: 1,
            padding: theme.spacing(1),
            borderRadius: 8,
            border: "1px solid #ddd",
            textAlign: "center",
            fontSize: "0.95rem",
        },
        priceSeparator: {
            fontSize: "0.95rem",
            color: theme.palette.text.secondary,
        },
        datePickerContainerrr: {
            display: "flex",
            alignItems: "center",
            border: "1px solid #ddd",
            borderRadius: 8,
            padding: theme.spacing(0.5),
            background: "#f9f9f9",
        },
        amenitiesSection: {
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: theme.spacing(2),
            marginBottom: theme.spacing(2),
            [theme.breakpoints.down("md")]: {
                gridTemplateColumns: "1fr 1fr",
            },
            [theme.breakpoints.down("sm")]: {
                gridTemplateColumns: "1fr",
            },
        },
        checkBoxContainer: {
            display: "flex",
            alignItems: "center",
            gap: '5px',
            marginBottom: "6px",
            backgroundColor: "transparent", // Sets the background color to white
            "& .MuiCheckbox-root": {
                color: "#890608", // Default color when unchecked
                backgroundColor: "transparent",
                '&.Mui-checked': {
                    color: "#890608", // Colorful tick when checked
                    backgroundColor: "white", // Keeps background white when checked
                },
            },
            "& .MuiSvgIcon-root": {
                fontSize: '18px', // Adjusts tick size if needed
            },
        },
        buttonContainer: {
            display: "flex", 
            justifyContent: "center",
            alignItems: "center", 
            marginTop: "5px",  
            height: "100%",          
          },
        searchButton: {
            backgroundColor: "#890608",
            color: "white",
            padding: "5px 20px",
            borderRadius: 8,
            maxWidth: 160,
            fontSize: "11px",
            alignItems: 'center',
            height: "30px",
            "&:hover": {
                backgroundColor: "#B5551B",
            },
        },
        sectionHeader: {
            fontSize: '13px', 
            fontWeight: 'bold', 
            marginBottom: theme.spacing(0.5),   
        },
        travelerContainer: {
            display: "flex",
            alignItems: "center",
            padding: "13px 32px",
            border: "1px solid #ddd",
            borderRadius: 8,
            cursor: "pointer",
            "&:hover": {
                background: "#f1f1f1",
            },
        },
        btnTraveller: {
            fontFamily: "Josefin Sans",
            fontSize: 13,
            opacity: 1,
            textTransform: "capitalize",
            padding: 0,
            marginLeft: theme.spacing(1),
            "& p": {
                marginLeft: 5,
                marginTop: 0,
                marginBottom: 0,
            },
        },
        popRadius: {
            padding: "0px",
            borderRadius: 16,
            fontSize: "11px"
        },
        mainRow: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            padding: "7px 32px 3px 32px",
            marginBottom: '15px',
            width: '100%',
            gap: '12px', // Space between each main container
        },
        mainRow2: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            padding: "7px 32px 3px 32px",
            marginBottom: '15px',
            width: '100%',
            gap: '12px', // Space between each main container
        },
        checkbox: {
        width: '16px', // Width for checkbox
        height: '16px', // Height for checkbox
        padding: 0, // Remove padding for compact appearance
    },
    dateInput: {
        '& .DateInput_input': {
            fontSize: '12px', // Set font size
            fontFamily: 'Josefin Sans, sans-serif', // Set font family
            color: '#A0A0A0', // Standard placeholder color
        },
        '& .DateInput_input__focused': {
            color: '#000000', // Color on focus
        },
        '& .DateInput_input__placeholder': {
            fontSize: '12px', // Placeholder font size
            fontFamily: 'Josefin Sans, sans-serif',
        },
    },
    searchContent: {
        width: '100%',
        margin: 'auto',
        [theme.breakpoints.down('sm')]: {
          flexDirection: 'column',
        },
      },
    searchIcon: {
        width: '15px',
        height: '15px',
    },
    marginTopLarge: {
        [theme.breakpoints.up('lg')]: {
          marginTop: 20,
        },
      },
    gridContainer: {
        [theme.breakpoints.up("md")]: {
            marginTop: "15px",
        },
    },
    gridItem: {
        [theme.breakpoints.up("md")]: {
            marginTop: "8px",
        },
    },
    sectionTypo: {        
        fontSize: '13px', 
        fontWeight: 'bold', 
        marginBottom: theme.spacing(0.5),
        paddingLeft: "32px",
    },
    advancedButton: {
        '&:hover': {
          backgroundColor: 'rgba(137, 6, 8, 0.1)',
        },
        transition: 'background-color 0.3s ease',
      },
        "@global": {
            ".DateInput_input": {
                fontFamily: "Josefin Sans",
                fontSize: 14,
                color: "#000000",
            },
        },
    })
);

interface HomeSearchProps {
    searchTypeName: "cars" | "apts" | "htls" | "trs" | "evts" | "rstt";
    search: any;
    setSearch: React.Dispatch<React.SetStateAction<any>>;
    paysList: any;
    paysSelected: any;
    paysLis: any;
    onChangeCherchPays: (value: any) => void;
    onChangeHandler: (event: any) => void;
    onChangeHandler2: (event: any) => void;
    onChangeHandler3: (event: any) => void;
    startDate: moment.Moment | null;
    endDate: moment.Moment | null;
    handlendDatesChange: (arg: { startDate: moment.Moment | null; endDate: moment.Moment | null }) => void;
    focusedInput: any;
    handleFocusChange: (arg: any) => void;
    handleClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
    nbrTraveller: number;
    handleClose: () => void;
    setnbrAdult: React.Dispatch<React.SetStateAction<number>>;
    setnbrAdul: React.Dispatch<React.SetStateAction<number>>;
    errorMessages: string;
    openError: boolean;
    handleCloseError: () => void;
    defaultCountry?: string;
    defaultCity?: string;
}


type Category = "eqt" | "rooms" | "type";
type AmenityKey = 
    | "pool"
    | "generator"
    | "beachfront"
    | "wifi"
    | "hotWater"
    | "video"
    | "parking"
    | "piscine"
    | "bordDeMer"
    | "freeWifi"
    | "eauChaude"
    | "generateur"
    | "proximiteRoutePrincipale"
    | "feteAutorisee";
type TypeKey = "house" 
  | "apartment" 
  | "room"
  | "hotelRoom"
  | "suite"
  | "citadine"
  | "berline"
  | "luxury"
  | "suv"
  | "pickUp"
  | "utilitaire"
  | "landSale"
  | "houseSale"
  | "apartmentRent"
  | "buildingSale"
  | "officeRent"
  | "houseRent"
  | "largeSpaceSale"
  | "restaurants"
  | "spas"
  | "nightlife"
  | "musees"
  | "attractions"
  | "visitesGuidees"
  | "sitesHistoriques"
  | "parcsNaturels"

type RoomKey = "oneRoom" | "twoRooms" | "threeRooms";

const DatePicker = ReactDatePicker as unknown as React.ComponentType<any>;

/*interface SearchState {
    price: string;
    priceMin: string;
} */

const countryService = new CountryService();
//const propertyService = new PropertyService();

export function HomeSearch(props: HomeSearchProps) {
    const classes = useStyles();
    const { t, i18n } = useTranslation<'common'>();
    const location = useLocation();
    const history = useHistory();
    const currencyContext = useContext(CurrencyContext);
    const { currency, } = currencyContext;
    const searchTypeName = props.searchTypeName;
    //const theme = useTheme();
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
        null
    );
    let [nbrTraveller, setnbrTraveller] = React.useState<number>(2);
    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;
    let [nbrAdult, setnbrAdult] = React.useState<number>(2);
    let [nbrEnfant, setnbrEnfant] = React.useState<number>(0);
    const [devise, setDevise] = React.useState("");
    const [devise2, setDevise2] = React.useState("");
    let [nbrBebe,] = React.useState<number>(0);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    // Initialize Language of calendar in SearchBar
    React.useEffect(() => {
        moment.locale(i18n.language);
    }, [i18n.language]);
    const [active, setActive] = React.useState(false);
    const [activeCity, setActiveCity] = React.useState(false);
    const [activeQuartier, setActiveQuartier] = React.useState(false);
    const [activePrice, setActivePrice] = React.useState(false);
    const [activePriceMin, setActivePriceMin] = React.useState(false);
    const [activeDate, setActiveDate] = React.useState(false);
    const [activeTraveler, setActiveTraveler] = React.useState(false);
    const [errorMessages, setErrorMessages] = React.useState<string>("");
    const [openError, setOpenError] = React.useState(false);
    //const [, setPropertyTypeList] = React.useState([])
    //const [, setEquipement] = React.useState([])
    const [startDate, setStartDate] = React.useState<moment.Moment | null>(null);
    const [endDate, setEndDate] = React.useState<moment.Moment | null>(null);
    const [countries, setCountries] = React.useState<IPays[]>([]); // Array of IPays objects
    const [cities, setCities] = React.useState<IVille[]>([]); // Array of IVille objects
    const [quartiers, setQuartiers] = React.useState<string[]>([]); // Array of quartiers (strings)
    const [selectedCountry, setSelectedCountry] = React.useState<string>(""); // Country ID as string
    const [selectedCity, setSelectedCity] = React.useState<string>(""); // City ID as string
    const [selectedQuartier, setSelectedQuartier] = React.useState<string>(""); // Quartier name as string
    const [selectedQuartiers, setSelectedQuartiers] = React.useState<string[]>([]);
    //const [focusedInput, setFocusedInput] = React.useState<FocusedInputShape | null>(null);
    const [minPrice, setMinPrice] = React.useState<string>("");
    const [maxPrice, setMaxPrice] = React.useState<string>("");
    const [tempMinPrice, setTempMinPrice] = React.useState<string>(""); // Temporary state
    const [tempMaxPrice, setTempMaxPrice] = React.useState<string>("");
    const [activeDropdown, setActiveDropdown] = React.useState<string | null>(null);
    //const activeLabelStyle = activeDropdown ? { color: "#890608", fontWeight: "bold" } : {};
    const [loadingCountries, setLoadingCountries] = React.useState(true); 
    const [eqt, setEqt] = React.useState<Record<AmenityKey, boolean>>({
        pool: false,
        generator: false,
        beachfront: false,
        wifi: false,
        hotWater: false,
        video: false,
        parking: false,
        piscine: false,
        bordDeMer: false,
        freeWifi: false,
        eauChaude: false,
        generateur: false,
        proximiteRoutePrincipale: false,
        feteAutorisee: false,
    });
    
    
    const [type, setType] = React.useState<Record<TypeKey, boolean>>({
        house: false,
        apartment: false,
        room: false,
        hotelRoom: false,
        suite: false,
        citadine: false,
        berline: false,
        luxury: false,
        utilitaire: false,
        suv: false,
        pickUp: false,
        landSale: false,
        houseSale: false,
        apartmentRent: false,
        buildingSale: false,
        officeRent: false,
        houseRent: false, 
        largeSpaceSale: false,
        restaurants: false,
        spas: false,
        nightlife: false,
        musees: false,
        attractions: false,
        visitesGuidees: false,
        sitesHistoriques: false,
        parcsNaturels: false,    
      });
      // State for radio buttons
      const [selectedCategory, setSelectedCategory] = React.useState<'restaurants' | 'otherActivities'>(
        searchTypeName === 'trs' 
            ? (location.pathname === '/activites' ? 'otherActivities' : 'restaurants')
            : 'otherActivities'
    );
    const [rooms, setRooms] = React.useState<Record<RoomKey, boolean>>({
        oneRoom: false,
        twoRooms: false,
        threeRooms: false,
    });
    const [isAdvancedSearchExpanded, setIsAdvancedSearchExpanded] = React.useState(false);

    // Handle radio button change
    const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const selectedValue = event.target.value as 'restaurants' | 'otherActivities';
        setSelectedCategory(selectedValue);
        
        // Update the type.restaurants state based on radio selection
        setType(prev => ({
            ...prev,
            restaurants: selectedValue === 'restaurants', // true if "restaurants" is selected
            // Optionally reset other activity checkboxes when switching to restaurants
            ...(selectedValue === 'restaurants' ? {
                spas: false,
                nightlife: false,
                musees: false,
                attractions: false,
                sitesHistoriques: false,
                parcsNaturels: false
            } : {})
        }));
    };

    
    const amenityLabels: Record<AmenityKey, string> = {
        pool: "Piscine",
        generator: "Générateur Electrique",
        beachfront: "Vue sur la mer",
        wifi: "Wifi gratuit",
        hotWater: "Eau chaude",
        video: "Vidéo disponible",
        parking: "Parking",
        piscine: "Piscine",
        bordDeMer: "Vue sur la mer",
        freeWifi: "Wifi gratuit",
        eauChaude: "Eau chaude",
        generateur: "Générateur Electrique",
        proximiteRoutePrincipale: "Proximité de la route principale",
        feteAutorisee: "Fêtes autorisées",
    };
    
    const typeLabels: Record<TypeKey, string> = {
        house: "Maison",
        apartment: "Appartement",
        room: "Chambre",
        hotelRoom: "Hôtel",
        suite: "Suite",
        citadine: "Citadine",
        berline: "Berline",
        luxury: "Luxury",
        utilitaire: "Utilitaire",
        suv: "SUV",
        pickUp: "Pick-Up",
        landSale: "Terrain en Vente",
        houseSale: "Maison en Vente",
        apartmentRent: "Appartement à Louer",
        buildingSale: "Immeuble en Vente",
        officeRent: "Bureau à Louer",
        houseRent: "Maison à Louer",
        largeSpaceSale: "Grand Espace en vente",
        restaurants: "Restaurant",
        spas: "Spa",
        nightlife: "Vie Nocturne",
        musees: "Musée",
        attractions: "Attraction",
        sitesHistoriques: "Site historique",
        visitesGuidees: "Visite Guidée",
        parcsNaturels: "Parc naturel"
    };
    const roomLabels: Record<RoomKey, string> = {
        oneRoom: "1",
        twoRooms: "2",
        threeRooms: "3",
    };
    
    // Query builders
    /*const buildAmenityQuery = () => {
        return Object.keys(amenities)
            .filter((key) => amenities[key as AmenityKey]) // filter on true values
            .map((key) => amenityLabels[key as AmenityKey]) // map to labels
            .join(",");
    }; */
    


    const buildTypeQuery = () => {
        if (searchTypeName === 'trs') {
            if (selectedCategory === 'restaurants') {
                // Always return restaurant label when this category is selected
                return typeLabels.restaurants;
            } else if (selectedCategory === 'otherActivities') {
                const activityTypes: TypeKey[] = [
                    'spas', 'nightlife', 'musees', 'attractions',
                    'sitesHistoriques', 'visitesGuidees', 'parcsNaturels'
                ];
                
                const selectedActivities = activityTypes.filter(key => type[key]);
                
                if (selectedActivities.length === 0) {
                    return [
                        "Spa",
                        "Vie Nocturne",
                        "Musée",
                        "Attraction",
                        "Site historique",
                        "Visite Guidée",
                        "Parc naturel"
                    ].join(",");
                }
                return selectedActivities.map(key => typeLabels[key]).join(",");
            }
        }
        return Object.keys(type)
            .filter(key => type[key as TypeKey])
            .map(key => typeLabels[key as TypeKey])
            .join(",");
    };
    
    const buildRoomsQuery = () => {
        return Object.keys(rooms)
            .filter((key) => rooms[key as RoomKey])
            .map((key) => roomLabels[key as RoomKey])
            .join(",");
    };

    const buildEqtQuery = () => {
        return Object.keys(eqt)
            .filter((key) => eqt[key as AmenityKey])
            .map((key) => amenityLabels[key as AmenityKey])
            .join(",");
    };
    
    
    let errors: string[] = [];

    
    /*
    React.useEffect(() => {
        propertyService
            .getAllPropertyTypes()
            .then((response) => {
                if (response.success) {
                    setPropertyTypeList(response.data);
                }
            })
            .catch((err: any) => {
                console.log(err);

            });
        /*propertyService
            .getAllEquipement()
            .then((response) => {

                if (response.success) {
                    setEquipement(response.data);
                }
            })
            .catch((err: any) => {
                console.log(err);

            });
    }, []) */

    // Reset expansion state when search type changes
    React.useEffect(() => {
        setIsAdvancedSearchExpanded(false);
    }, [searchTypeName]);

    // Reset restaurant state when not in trs search
    React.useEffect(() => {
    if (searchTypeName === 'trs') {
            setSelectedCategory(location.pathname === '/activites' ? 'otherActivities' : 'restaurants');
        } else {
            setSelectedCategory('otherActivities');
            setType(prev => ({
                ...prev,
                restaurants: false
            }));
        }
    }, [searchTypeName, location.pathname]);
        

    React.useEffect(() => {
        // Fetch countries with populated 'villes' field
        setLoadingCountries(true); // Start loading
        countryService.getAllCountries()
            .then((response: { success: boolean; data: IPays[] }) => {
                if (response.success) {
                    setCountries(response.data);
                } else {
                    console.error("Failed to fetch countries");
                }
            })
            .catch((err: any) => {
                console.error("Error fetching countries:", err);
            })
            .finally(() => {
                setLoadingCountries(false); // Stop loading
            });
    }, []);

    React.useEffect(() => {
        // Fetch countries with populated 'villes' field
        setLoadingCountries(true); // Start loading
        countryService.getAllCountries()
            .then((response: { success: boolean; data: IPays[] }) => {
                if (response.success) {
                    // Filter countries to only include those that have the searchTypeName in applicableSearchTypes
                    const filteredCountries = response.data.filter((country: IPays) => 
                        country.applicableSearchTypes && 
                        country.applicableSearchTypes.includes(searchTypeName)
                    );
                    setCountries(filteredCountries);
                } else {
                    console.error("Failed to fetch countries");
                }
            })
            .catch((err: any) => {
                console.error("Error fetching countries:", err);
            })
            .finally(() => {
                setLoadingCountries(false); // Stop loading
            });
    }, [searchTypeName]); // Added searchTypeName as dependency


    React.useEffect(() => {
        if (selectedCountry) {
            const country = countries.find(country => country._id.toString() === selectedCountry);
            if (country) {
                // Filter cities to only include those that have the searchTypeName in applicableSearchTypes
                const filteredCities = (country.villes || []).filter((city: IVille) => 
                    city.applicableSearchTypes && 
                    city.applicableSearchTypes.includes(searchTypeName)
                );
                setCities(filteredCities);
                setDevise(country.currencyCode);
                setDevise2(country.currencyCode);
            } else {
                setCities([]);
                setDevise("");
                setDevise2("");
            }
            setSelectedCity(""); // Reset city and quartier when country changes
            setQuartiers([]);
            setSelectedQuartier("");
        }
    }, [selectedCountry, countries, searchTypeName]); // Added searchTypeName as dependency

    React.useEffect(() => {
        if (selectedCity) {
            const city = cities.find(city => city?._id?.toString() === selectedCity);
            if (city) {
                // Filter quartiers only if the city supports the current searchTypeName
                if (city.applicableSearchTypes && city.applicableSearchTypes.includes(searchTypeName)) {
                    setQuartiers([...city?.quartiers || []]);
                } else {
                    setQuartiers([]); // No quartiers if city doesn't support the search type
                }
            } else {
                setQuartiers([]);
            }
            setSelectedQuartier(""); // Reset selected quartier on city change
        } else {
            setQuartiers([]);
            setSelectedQuartier("");
        }
    }, [selectedCity, cities, searchTypeName]); // Added searchTypeName as dependency


    /*React.useEffect(() => {
        //console.log('Current state of type:', type);
    }, [type]);
    
    React.useEffect(() => {
        //console.log('Current state of rooms:', rooms);
    }, [rooms]);
    
    React.useEffect(() => {
        //console.log('Current state of amenities:', amenities);
    }, [amenities]);*/


    const handleTempMinPriceChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
        //console.log(`Temp minPrice before update: ${tempMinPrice}`);;
        setTempMinPrice(e.target.value); // Directly update temporary state
        //console.log(`Temp minPrice after update: ${e.target.value}`);
    };
    
    const handleTempMaxPriceChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
        //console.log(`Temp maxPrice before update: ${tempMaxPrice}`);
        setTempMaxPrice(e.target.value); // Directly update temporary state
        //console.log(`Temp maxPrice after update: ${e.target.value}`);
    };
    


    const onChangeCountry = (country: IPays | null) => {
        if (country && country._id) {
            setSelectedCountry(country._id);
            
            // Filter cities based on searchTypeName
            const filteredCities = (country.villes || []).filter((city: IVille) => 
                city.applicableSearchTypes && 
                city.applicableSearchTypes.includes(searchTypeName)
            );
            setCities(filteredCities);
            setSelectedCity("");
            setSelectedQuartier("");
            setQuartiers([]);
        } else {
            setSelectedCountry("");
            setCities([]);
            setSelectedCity("");
            setSelectedQuartier("");
            setQuartiers([]);
        }
    };
    
    

    const onChangeCity = (city: IVille | null): void => {
        if (city && city._id) {
            // Check if city supports the current searchTypeName
            if (city.applicableSearchTypes && city.applicableSearchTypes.includes(searchTypeName)) {
                setSelectedCity(city._id);
                setQuartiers(city.quartiers || []);
            } else {
                setSelectedCity("");
                setQuartiers([]);
            }
            setSelectedQuartier("");
        } else {
            setSelectedCity("");
            setQuartiers([]);
            setSelectedQuartier("");
        }
    };


    const onChangeQuartier = (selectedValues: string[]) => {
        if (selectedValues.length <= 5) {
            setSelectedQuartiers(selectedValues);
        }
    };
    
  /*
     const onChangePriceMin = (value: string | number): void => {
        const formattedValue = value?.toString().trim();
        setMinPrice(formattedValue); // Update state
        query.set("priceMin", formattedValue); // Set query parameter
        history.push({ search: query.toString() }); // Update URL
    };

    const onChangePriceMax = (value: string | number): void => {
        const formattedValue = value?.toString().trim();
        setMaxPrice(formattedValue); // Update state
        query.set("price", formattedValue); // Set query parameter
        history.push({ search: query.toString() }); // Update URL
    };


     const handlendDatesChange = ({ startDate, endDate }: { startDate: moment.Moment | null; endDate: moment.Moment | null }) => {
        //console.log("Selected Start Date:", startDate?.format("YYYY-MM-DD"));
        //console.log("Selected End Date:", endDate?.format("YYYY-MM-DD"));
        setStartDate(startDate);
        setEndDate(endDate);
    }; */

    
    

/*

    const handleClickActive = () => {
        if (!loadingCountries) {
            setActive(true);
        }
    };
    const handleClickActiveCity = () => {
        setActiveCity(true)
    };

    const handleClickActiveQuartier = () => {
        setActiveQuartier(true)
    }; */

    const handleClickActive = () => setActiveDropdown("country");
    const handleClickActiveCity = () => setActiveDropdown("city");
    const handleClickActiveQuartier = () => setActiveDropdown("quartier");

    const handleClickActivePrice = () => setActiveDropdown("price");
    const handleClickActivePriceMin = () => setActiveDropdown("priceMin");
    const handleClickActiveDate = () => setActiveDropdown("date");
    const handleClickActiveTraveler = () => setActiveDropdown("traveller");

    // Reset activeDropdown on click outside
    React.useEffect(() => {
        const handleClickOutside = () => setActiveDropdown(null);
        window.addEventListener("mousedown", handleClickOutside);
        return () => {
            window.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    React.useEffect(() => {
        window.addEventListener('mousedown', () => setActiveQuartier(false));

        // cleanup this component
        return () => {
            window.removeEventListener('mousedown', handleClickActiveQuartier);
        };
    }, [activeQuartier]);
    
    React.useEffect(() => {
        window.addEventListener('mousedown', () => setActiveCity(false));

        // cleanup this component
        return () => {
            window.removeEventListener('mousedown', handleClickActiveCity);
        };
    }, [activeCity]);

    /*const handleClickActivePrice = () => {
        setActivePrice(true)
    };*/

    React.useEffect(() => {
        window.addEventListener('mousedown', () => setActivePrice(false));

        // cleanup this component
        return () => {
            window.removeEventListener('mousedown', handleClickActivePrice);
        };
    }, [activePrice]);

    /*const handleClickActivePriceMin = () => {
        setActivePrice(true)
    };*/

    React.useEffect(() => {
        window.addEventListener('mousedown', () => setActivePriceMin(false));

        // cleanup this component
        return () => {
            window.removeEventListener('mousedown', handleClickActivePriceMin);
        };
    }, [activePrice]);

    React.useEffect(() => {
        // Set default values for country and city based on props
        if (props.defaultCountry) {
            // Set default country value
        }
        
        if (props.defaultCity) {
            // Set default city value
        }
    }, [props.defaultCountry, props.defaultCity]);

    /*const handleClickActiveDate = () => {
        setActiveDate(true)
    };*/
    React.useEffect(() => {
        setnbrTraveller(nbrAdult + nbrEnfant + nbrBebe);
    }, [nbrAdult, nbrEnfant, nbrBebe]);
    /*const handleClickActiveTraveler = () => {
        setActiveTraveler(true)
    };*/

    React.useEffect(() => {
        window.addEventListener('mousedown', () => setActiveTraveler(false));

        // cleanup this component
        return () => {
            window.removeEventListener('mousedown', handleClickActiveTraveler);
        };
    }, [activeTraveler]);

    React.useEffect(() => {
        window.addEventListener('mousedown', () => setActiveDate(false));

        // cleanup this component
        return () => {
            window.removeEventListener('mousedown', handleClickActiveDate);
        };
    }, [activeDate]);
    //const bp = useMediaQuery(theme.breakpoints.down("xs"));
    React.useEffect(() => {
        window.addEventListener('mousedown', () => setActive(false));

        // cleanup this component
        return () => {
            window.removeEventListener('mousedown', handleClickActive);
        };
    }, [active]);

    const isSearchValidate = (): boolean => {
        // Initialize errors array if it's local to this function
        let errors: string[] = [];
    
        // Check if selectedCountry is empty or undefined
        if (!selectedCountry) {
            if (!errors.includes("EMPTY COUNTRY")) {
                errors = [...errors, "EMPTY COUNTRY"];
            }
        }
    
        // Additional conditions if needed, for example checking start and end dates
        else if (props.startDate != null && props.endDate != null) {
            // Additional validation logic can go here
        }
    
        // Return true if no errors, false otherwise
        return errors.length === 0;
    };
    
    const validateSearch = (): boolean => {
        if (!selectedCountry) {
            setErrorMessages(t("searchBar.selectPays"));
            setOpenError(true);
            return false;
        }
        
        // Add city validation specifically for restaurant searches
        if (searchTypeName === 'trs' && selectedCategory === 'restaurants' && !selectedCity) {
            setErrorMessages(t("searchBar.selectCity"));
            setOpenError(true);
            return false;
        }
        
        return true;
    };

    /*const isSearchValidated = (): boolean => {
        // Clear errors at the start of validation
        errors = [];
        
        // Ensure selectedCountry is defined and not empty
        if (!selectedCountry) {
            if (!errors.includes("EMPTY COUNTRY")) {
                errors.push("EMPTY COUNTRY");
            }
        }
    
        // Additional validation for dates if necessary
        if (!props.startDate || !props.endDate) {
            if (!errors.includes("MISSING DATES")) {
                errors.push("MISSING DATES");
            }
        }
    
        return errors.length === 0; // Return true if no errors, false otherwise
    };*/
    
    const showErrorsMessages = () => {
        let allErrorMessages = "";
        errors.forEach((error) => {
            if (error === "EMPTY COUNTRY") {
                allErrorMessages += "," + t(`label.error.${ESearchErrorMessages.EmptyName}`);
            }
        });
        setErrorMessages(
            allErrorMessages.substring(1, allErrorMessages.length)
        );
        setOpenError(true);
    };
    const query = useQuery()
    

    const handleCloseError = () => {
        setOpenError(false);
    };

    //const bpSm = useMediaQuery(theme.breakpoints.down("sm"));
    //const bpXs = useMediaQuery(theme.breakpoints.down("sm"));

    const getTranslationKey = (key: string): string => {
        return `homeSearch.${props.searchTypeName}.${key}`;
    }


    const handleSearch = () => {

        // Validate first
        if (!validateSearch()) {
            return; // Exit if validation fails
        }

        let super_offer = 0;

        if (!isSearchValidate()) {
        showErrorsMessages(); // Show error messages if validation fails
        return; // Exit the function early
        }

        setErrorMessages("");

        setMinPrice(tempMinPrice);
        setMaxPrice(tempMaxPrice);

        // Find the selected country in countries list by _id
        const selectedCountryObj = countries.find(
            (country) => country._id.toString() === selectedCountry
        ) as IPays | undefined;

       

        if (!selectedCountryObj) {
            setErrorMessages(t("searchBar.selectPays")); // Already covers missing country
            setOpenError(true);
            return;
        }

        // Retrieve country ID
        const countryId = selectedCountryObj._id;


        // Find the selected city within the selected country, if any
        const selectedCityObj = selectedCountryObj.villes?.find(
            (city) => city._id?.toString() === selectedCity
        ) as IVille | undefined;

        const cityId = selectedCityObj?._id || ""; // Allow cityId to be empty

        //console.log("maxPrice:", tempMaxPrice);
        //console.log("minPrice:", tempMinPrice);

        // Set search query parameters based on selected criteria
        query.set("search_pays", countryId); // Use country _id
        query.set("search_adresse", cityId); // Use city _id, or leave blank
        query.set("quartier", selectedQuartiers.join(","));
        query.set("offer", super_offer.toString());
        query.set("price", tempMaxPrice || ""); // Use local input
        query.set("priceMin", tempMinPrice || ""); // Use local input
        query.set("currencyBase", devise || "");
        query.set("currency", currency.toString());
        query.set("refreshData", "1");
        query.set("travellerChildTotal", nbrEnfant.toString());
        query.set("travellerAdultTotal", nbrAdult.toString());
        query.set("type", props.searchTypeName);
        query.set("page", "1");

        if (startDate && endDate) {
            query.set("dci", startDate.format("YYYY/MM/DD"));
            query.set("dco", endDate.format("YYYY/MM/DD"));
        } else {
            query.set("dci", "");
            query.set("dco", "");
        }

        query.set("eqt", buildEqtQuery());
        //query.set("click", buildTypeQuery());
        query.set("rooms", buildRoomsQuery());

        if (searchTypeName === 'trs') {
            query.set("click", buildTypeQuery());
        } else {
            // For non-trs searches, filter out restaurant-related params
            const filteredTypes = buildTypeQuery()
                .split(',')
                .filter(t => t !== typeLabels.restaurants)
                .join(',');
            query.set("click", filteredTypes);
        }

        //console.log("Final Query:", query.toString());
        history.push({ pathname: "/search", search: query.toString() });
    };
    
    

    const handleCheckboxChange = (category: Category, key: string) => {
        if (category === "eqt") {
            setEqt((prev) => ({ ...prev, [key]: !prev[key as AmenityKey] }));
        } else if (category === "type") {
            setType((prev) => ({ ...prev, [key]: !prev[key as TypeKey] }));
        } else if (category === "rooms") {
            setRooms((prev) => ({ ...prev, [key]: !prev[key as RoomKey] }));
        }
    };

const shouldRemoveMarginTopLarge = location.pathname === '/voitures' || location.pathname === '/immobilier';
    

return (
    <>
    <form className={classes.searchContainer}>
      <Grid container spacing={2} className={classes.searchContent} >
        {/* Top Row: Place, City, and Quartier Selectors */}
        <Grid item xs={12} md={4} lg={4}  className={clsx(classes.label, { [classes.selectedLabel]: activeDropdown === "country" })} onClick={handleClickActive}>
                <div style={{ padding: "1px 0", }}>
                    <h3 style={{ fontSize: '13px', margin: '4px 0' }}>
                        {t(getTranslationKey('destination'))}
                    </h3>
                    {loadingCountries ? (
                        <CircularProgress
                            size={20}
                            style={{ color: "#890608", marginTop: 8 }}
                        />
                    ) : (
                        <PnbPlaceSelector
                            noHeading
                            secondStyle
                            width="100%"
                            title={t(getTranslationKey("whereToGo"))}
                            placeHolder={t(getTranslationKey("whichCountry"))}
                            id="propertyEquipments1"
                            name="propertyEquipments1"
                            selectedValues={selectedCountry}
                            values={countries}
                            onChangeSelect={onChangeCountry}
                        />
                    )}
                </div>
        </Grid>
        
        <Grid item xs={12} md={4} lg={4}  className={clsx(classes.label, { [classes.selectedLabel]: activeDropdown === "city" })} onClick={handleClickActiveCity} >
              
                    <div style={{ lineHeight: 1.3 }} >
                        <h3 style={{ fontSize: '13px', margin: '4px 0' }}>
                            {t(getTranslationKey('city'))}
                        </h3>
                        <PnbPlaceCitySelector
                            noHeading
                            secondStyle
                            width="100%"
                            title={t("home.ville")}
                            placeHolder={t(getTranslationKey('whichCity'))}
                            id="villeSearchDropdown" 
                            name="villeSearchDropdown"
                            selectedValues={selectedCity}
                            values={cities}
                            onChangeSelect={onChangeCity}
                        />
                    </div>
                
            
        </Grid>
        {(searchTypeName !== "rstt" && searchTypeName !== "cars") && (
        <>
            <Grid item xs={12} md={4} lg={4} className={clsx(classes.label, { [classes.selectedLabel]: activeDropdown === "quartier" })} onClick={handleClickActiveQuartier}>
                
                        <div style={{ lineHeight: 1.3 }} >
                        <div style={{ display: "flex", alignItems: "center", marginBottom: 10 }}>
                            <h3 style={{ fontSize: '13px', margin: '4px 0', flex: 1 }}>
                                {t(getTranslationKey('quartier'))}
                            </h3>
                            <span style={{ fontSize: 12, color: "#890608", marginLeft: 10 }}>
                                {selectedQuartiers.length}/5 {t("home.selected")}
                            </span>
                        </div>
                            <PnbPlaceQuartierSelector
                                noHeading
                                secondStyle
                                width="100%"
                                title={t("home.quartier")}
                                placeHolder={t(getTranslationKey('whichDistrict'))}
                                id="quartierSearchDropdown2" 
                                name="quartierSearchDropdown2"
                                selectedQuartierValues={selectedQuartiers}
                                values={quartiers}
                                onChangeSelect={onChangeQuartier}
                            />
                        </div>
                    
                
            </Grid>
        </>
        )}
        
        {searchTypeName !== "trs" && (
        <>    
            <Grid 
                item 
                xs={12} 
                md={4}
                className={clsx(classes.label, {
                    [classes.marginTopLarge]: !shouldRemoveMarginTopLarge, // Apply marginTopLarge only if the condition is false
                    [classes.selectedLabel]: active
                })}
            >
                <div className={classes.priceInputContainer} style={{ alignItems: 'center' }}>
                    <label onClick={handleClickActivePriceMin}>
                        <div style={{ lineHeight: 1.3 }}>
                            <h3 style={{ fontSize: '12px', margin: '4px 0' }}>
                                {`${t(getTranslationKey('priceMin'))}`}
                            </h3>
                            <SearchPrice 
                                id="price-min-input"  // Unique ID for min price
                                name="priceMin"       // Name for form handling
                                handleChange={handleTempMinPriceChange}
                                placeholder={t("searchBar.priceMin")} 
                                defaultValue={minPrice}
                            />                          
                        </div>
                    </label>                            
                    <span className={classes.priceSeparator}>-</span>
                    <label onClick={handleClickActivePrice}>
                        <div style={{ lineHeight: 1.3 }}>
                            <h3 style={{ fontSize: '12px', margin: '4px 0' }}>
                                {`${t(getTranslationKey('priceMax'))}`}
                            </h3> 
                            <SearchPrice 
                                id="price-max-input"  // Unique ID for max price
                                name="priceMax"       // Name for form handling
                                handleChange={handleTempMaxPriceChange}
                                placeholder={t("searchBar.price")}
                                defaultValue={maxPrice}
                            /> 
                        </div>
                    </label>    
                </div>    
            </Grid>
        </>
        )}


        {(searchTypeName !== "rstt" && searchTypeName !== "trs") && (
        <>
            <Grid item xs={12} md={4} className={clsx(classes.label, classes.marginTopLarge, { [classes.selectedLabel]: activeDropdown === "date" })}  onClick={handleClickActiveDate}>
                <div style={{ lineHeight: 0.8, marginTop: 1 }}>
                    <h3 style={{ fontSize: '13px', margin: '4px 0' }}>
                        {t(getTranslationKey('when'))}
                    </h3>
                    <div className={classes.searchDateContainer}>
                        <div className={classes.datePickerContainer}>
                            <DatePicker
                                id="check-in-date"
                                name="checkInDate"
                                selected={startDate?.toDate()}
                                onChange={(date: Date | null) => setStartDate(date ? moment(date) : null)}
                                selectsStart
                                startDate={startDate?.toDate()}
                                endDate={endDate?.toDate()}
                                placeholderText={t(getTranslationKey("checkIn"))}
                                dateFormat="dd/MM/yyyy"
                                className="transparent-input"
                                minDate={new Date()} // This disables past dates
                            />
                            
                            <span className="separator">→</span>
                            
                            <DatePicker
                                id="check-out-date"
                                name="checkOutDate"
                                selected={endDate?.toDate()}
                                onChange={(date: Date | null) => setEndDate(date ? moment(date) : null)}
                                selectsEnd
                                startDate={startDate?.toDate()}
                                endDate={endDate?.toDate()}
                                minDate={startDate?.toDate()}
                                placeholderText={t(getTranslationKey("checkOut"))}
                                dateFormat="dd/MM/yyyy"
                                className="transparent-input"
                            />
                        </div>
                    </div>
                </div>
            </Grid>
            
            <Grid item xs={12} md={4} className={clsx(classes.label, classes.marginTopLarge, { [classes.selectedLabel]: activeDropdown === "traveller" })} onClick={handleClickActiveTraveler} >
                    
                        <div style={{ lineHeight: 0.6, marginTop: 2 }}>
                            <h3 style={{ fontSize: '13px', margin: '4px 0' }}>{t(getTranslationKey('travellers'))}</h3>
                            <div className={classes.searchTraveller}>
                                <Button className={classes.btnTraveller} onClick={handleClick}>
                                    {`${t(getTranslationKey("guest"))}: ${nbrTraveller}`}
                                </Button>
                                <Popover
                                    classes={{ paper: classes.popRadius }}
                                    style={{ borderRadius: "32px" }}
                                    id={id}
                                    open={open}
                                    anchorEl={anchorEl}
                                    onClose={handleClose}
                                    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                                    transformOrigin={{ vertical: "top", horizontal: "center" }}
                                >
                                    <div className={classes.popContainer}>
                                        <ItemPopover
                                            title={t(getTranslationKey("adult"))}
                                            subtitle={t(getTranslationKey("adultSub"))}
                                            value={nbrAdult}
                                            increment={() => setnbrAdult(nbrAdult + 1)}
                                            decrement={() => setnbrAdult(nbrAdult - 1)}
                                        />
                                        <ItemPopover
                                            title={t(getTranslationKey("children"))}
                                            subtitle={t(getTranslationKey("childrenSub"))}
                                            value={nbrEnfant}
                                            increment={() => setnbrEnfant(nbrEnfant + 1)}
                                            decrement={() => setnbrEnfant(nbrEnfant - 1)}
                                        />
                                    </div>
                                </Popover>
                            </div>
                        </div>
            </Grid>
        </>
        )}

        {searchTypeName !== 'trs' && (
        <Grid item xs={12} style={{ textAlign: 'center', margin: '10px 0' }}>
            <Button
            onClick={() => setIsAdvancedSearchExpanded(!isAdvancedSearchExpanded)}
            style={{
                textTransform: 'none',
                color: '#890608',
                fontWeight: 'bold',
                fontSize: '0.8rem',
                padding: '4px 12px',
                border: '1px solid lightgrey',
                borderRadius: '4px',
            }}
            endIcon={
                isAdvancedSearchExpanded ? (
                <KeyboardArrowUpIcon style={{ color: '#890608' }} />
                ) : (
                <KeyboardArrowDownIcon style={{ color: '#890608' }} />
                )
            }
            >
            {isAdvancedSearchExpanded
                ? t('label.hideAdvanced')
                : t('label.advancedSearch')}
            </Button>
        </Grid>
        )}

        {searchTypeName === "apts" && isAdvancedSearchExpanded && (
            <Grid container spacing={3} className={classes.gridContainer}>
                <Grid item xs={12} md={6}>
                    <div className={classes.mainRow} >
                        <div>
                            <Typography className={classes.sectionHeader}>{t("home.type")}</Typography>
                            <div className={classes.checkBoxContainer}>
                                <Checkbox 
                                    checked={type.room} 
                                    onChange={() => handleCheckboxChange("type", "room")} 
                                    className={classes.checkbox} 
                                />
                                <label className={classes.labels}>{t("amenities.room")}</label>
                            </div>
                            <div className={classes.checkBoxContainer}>
                                <Checkbox 
                                    checked={type.apartment} 
                                    onChange={() => handleCheckboxChange("type", "apartment")} 
                                    className={classes.checkbox} 
                                />
                                <label className={classes.labels}>{t("amenities.apartment")}</label>
                            </div>
                            <div className={classes.checkBoxContainer}>
                                <Checkbox 
                                    checked={type.house} 
                                    onChange={() => handleCheckboxChange("type", "house")} 
                                    className={classes.checkbox} 
                                />
                                <label className={classes.labels}>{t("amenities.house")}</label>
                            </div>
                        </div>

                        <Divider orientation="vertical" flexItem className={classes.divider} />

                        <div>
                            <Typography className={classes.sectionHeader}>{t("home.number-of-rooms")}</Typography>
                            <div className={classes.checkBoxContainer}>
                                <Checkbox 
                                    checked={rooms.oneRoom} 
                                    onChange={() => handleCheckboxChange("rooms", "oneRoom")} 
                                    className={classes.checkbox} 
                                />
                                <label className={classes.labels}>{t("amenities.1room")}</label>
                            </div>
                            <div className={classes.checkBoxContainer}>
                                <Checkbox 
                                    checked={rooms.twoRooms} 
                                    onChange={() => handleCheckboxChange("rooms", "twoRooms")} 
                                    className={classes.checkbox} 
                                />
                                <label className={classes.labels}>{t("amenities.2rooms")}</label>
                            </div>
                            <div className={classes.checkBoxContainer}>
                                <Checkbox 
                                    checked={rooms.threeRooms} 
                                    onChange={() => handleCheckboxChange("rooms", "threeRooms")} 
                                    className={classes.checkbox} 
                                />
                                <label className={classes.labels}>{t("amenities.3roomsAndMore")}</label>
                            </div>
                        </div>
                    </div>            
                </Grid>
                <Grid item xs={12} md={6} className={classes.gridItem}>
                    <Typography className={classes.sectionTypo}>{t("home.popularAmenities")}</Typography>
                    <div className={classes.mainRow2}>                   
                        <div>                        
                            <div className={classes.checkBoxContainer}>
                                <Checkbox 
                                    checked={eqt.piscine} 
                                    onChange={() => handleCheckboxChange("eqt", "piscine")} 
                                    className={classes.checkbox} 
                                />
                                <label className={classes.labels}>{t("amenities.piscine")}</label>
                            </div>
                            <div className={classes.checkBoxContainer}>
                                <Checkbox 
                                    checked={eqt.bordDeMer} 
                                    onChange={() => handleCheckboxChange("eqt", "bordDeMer")} 
                                    className={classes.checkbox} 
                                />
                                <label className={classes.labels}>{t("amenities.bordDeMer")}</label>
                            </div>
                            <div className={classes.checkBoxContainer}>
                                <Checkbox 
                                    checked={eqt.freeWifi} 
                                    onChange={() => handleCheckboxChange("eqt", "freeWifi")} 
                                    className={classes.checkbox} 
                                />
                                <label className={classes.labels}>{t("amenities.freeWifi")}</label>
                            </div>
                            <div className={classes.checkBoxContainer}>
                                <Checkbox 
                                    checked={eqt.eauChaude} 
                                    onChange={() => handleCheckboxChange("eqt", "eauChaude")} 
                                    className={classes.checkbox} 
                                />
                                <label className={classes.labels}>{t("amenities.eauChaude")}</label>
                            </div>
                        </div>

                        <Divider orientation="vertical" flexItem className={classes.divider} />

                        <div>
                            
                            <div className={classes.checkBoxContainer}>
                                <Checkbox 
                                    checked={eqt.generateur} 
                                    onChange={() => handleCheckboxChange("eqt", "generateur")} 
                                    className={classes.checkbox} 
                                />
                                <label className={classes.labels}>{t("amenities.generateur")}</label>
                            </div>
                            <div className={classes.checkBoxContainer}>
                                <Checkbox 
                                    checked={eqt.parking} 
                                    onChange={() => handleCheckboxChange("eqt", "parking")} 
                                    className={classes.checkbox} 
                                />
                                <label className={classes.labels}>{t("amenities.parking")}</label>
                            </div>
                            <div className={classes.checkBoxContainer}>
                                <Checkbox 
                                    checked={eqt.proximiteRoutePrincipale} 
                                    onChange={() => handleCheckboxChange("eqt", "proximiteRoutePrincipale")} 
                                    className={classes.checkbox} 
                                />
                                <label className={classes.labels}>{t("amenities.proximiteRoutePrincipale")}</label>
                            </div>
                            <div className={classes.checkBoxContainer}>
                                <Checkbox 
                                    checked={eqt.feteAutorisee} 
                                    onChange={() => handleCheckboxChange("eqt", "feteAutorisee")} 
                                    className={classes.checkbox} 
                                />
                                <label className={classes.labels}>{t("amenities.feteAutorisee")}</label>
                            </div>
                        </div>
                    </div>
                </Grid>
            </Grid>   
        )}


        {searchTypeName === "htls" && isAdvancedSearchExpanded && (
        <Grid container spacing={3} className={classes.gridContainer}>    
        <Grid item xs={12} md={6}>
          <div className={classes.mainRow} >
            
                    <div>
                        <Typography className={classes.sectionHeader}>{t("home.type")}</Typography>
                        <div className={classes.checkBoxContainer}>
                            <Checkbox 
                                checked={type.room} 
                                onChange={() => handleCheckboxChange("type", "hotelRoom")} 
                                className={classes.checkbox} 
                            />
                            <label className={classes.labels}>{t("amenities.hotel-room")}</label>
                        </div>
                        <div className={classes.checkBoxContainer}>
                            <Checkbox 
                                checked={type.apartment} 
                                onChange={() => handleCheckboxChange("type", "suite")} 
                                className={classes.checkbox} 
                            />
                            <label className={classes.labels}>{t("amenities.suite")}</label>
                        </div>
                        <div className={classes.checkBoxContainer}>
                            <Checkbox 
                                checked={type.house} 
                                onChange={() => handleCheckboxChange("type", "house")} 
                                className={classes.checkbox} 
                            />
                            <label className={classes.labels}>{t("amenities.house")}</label>
                        </div>
                    </div>

                    <Divider orientation="vertical" flexItem className={classes.divider} />

                    <div>
                        <Typography className={classes.sectionHeader}>{t("home.number-of-rooms")}</Typography>
                        <div className={classes.checkBoxContainer}>
                            <Checkbox 
                                checked={rooms.oneRoom} 
                                onChange={() => handleCheckboxChange("rooms", "oneRoom")} 
                                className={classes.checkbox} 
                            />
                            <label className={classes.labels}>{t("amenities.1room")}</label>
                        </div>
                        <div className={classes.checkBoxContainer}>
                            <Checkbox 
                                checked={rooms.twoRooms} 
                                onChange={() => handleCheckboxChange("rooms", "twoRooms")} 
                                className={classes.checkbox} 
                            />
                            <label className={classes.labels}>{t("amenities.2rooms")}</label>
                        </div>
                        <div className={classes.checkBoxContainer}>
                            <Checkbox 
                                checked={rooms.threeRooms} 
                                onChange={() => handleCheckboxChange("rooms", "threeRooms")} 
                                className={classes.checkbox} 
                            />
                            <label className={classes.labels}>{t("amenities.3roomsAndMore")}</label>
                        </div>
                    </div>
                </div>
        </Grid>
        <Grid item xs={12} md={6} className={classes.gridItem}>
            <Typography className={classes.sectionTypo}>{t("home.popularAmenities")}</Typography>
                <div className={classes.mainRow}>
                    <div>                        
                        <div className={classes.checkBoxContainer}>
                            <Checkbox 
                                checked={eqt.piscine} 
                                onChange={() => handleCheckboxChange("eqt", "piscine")} 
                                className={classes.checkbox} 
                            />
                            <label className={classes.labels}>{t("amenities.piscine")}</label>
                        </div>
                        <div className={classes.checkBoxContainer}>
                            <Checkbox 
                                checked={eqt.bordDeMer} 
                                onChange={() => handleCheckboxChange("eqt", "bordDeMer")} 
                                className={classes.checkbox} 
                            />
                            <label className={classes.labels}>{t("amenities.bordDeMer")}</label>
                        </div>
                        <div className={classes.checkBoxContainer}>
                            <Checkbox 
                                checked={eqt.freeWifi} 
                                onChange={() => handleCheckboxChange("eqt", "freeWifi")} 
                                className={classes.checkbox} 
                            />
                            <label className={classes.labels}>{t("amenities.freeWifi")}</label>
                        </div>
                        <div className={classes.checkBoxContainer}>
                            <Checkbox 
                                checked={eqt.eauChaude} 
                                onChange={() => handleCheckboxChange("eqt", "eauChaude")} 
                                className={classes.checkbox} 
                            />
                            <label className={classes.labels}>{t("amenities.eauChaude")}</label>
                        </div>
                    </div>

                    <Divider orientation="vertical" flexItem className={classes.divider} />

                    <div>
                        <div className={classes.checkBoxContainer}>
                            <Checkbox 
                                checked={eqt.generateur} 
                                onChange={() => handleCheckboxChange("eqt", "generateur")} 
                                className={classes.checkbox} 
                            />
                            <label className={classes.labels}>{t("amenities.generateur")}</label>
                        </div>
                        <div className={classes.checkBoxContainer}>
                            <Checkbox 
                                checked={eqt.parking} 
                                onChange={() => handleCheckboxChange("eqt", "parking")} 
                                className={classes.checkbox} 
                            />
                            <label className={classes.labels}>{t("amenities.parking")}</label>
                        </div>
                        <div className={classes.checkBoxContainer}>
                            <Checkbox 
                                checked={eqt.proximiteRoutePrincipale} 
                                onChange={() => handleCheckboxChange("eqt", "proximiteRoutePrincipale")} 
                                className={classes.checkbox} 
                            />
                            <label className={classes.labels}>{t("amenities.proximiteRoutePrincipale")}</label>
                        </div>
                        <div className={classes.checkBoxContainer}>
                            <Checkbox 
                                checked={eqt.feteAutorisee} 
                                onChange={() => handleCheckboxChange("eqt", "feteAutorisee")} 
                                className={classes.checkbox} 
                            />
                            <label className={classes.labels}>{t("amenities.feteAutorisee")}</label>
                        </div>
                    </div>
                </div>
            </Grid>
            </Grid>  
        )}


        {searchTypeName === "cars" && isAdvancedSearchExpanded && (
            <Grid item xs={12} md={8} lg={8}  className={classes.gridContainer}>
            <div className={classes.mainRow} >
                        <div>
                            <Typography className={classes.sectionHeader}>{t("home.type-cars")}</Typography>
                            <div className={classes.checkBoxContainer}>
                                <Checkbox 
                                    checked={type.citadine} 
                                    onChange={() => handleCheckboxChange("type", "citadine")} 
                                    className={classes.checkbox} 
                                />
                                <label className={classes.labels}>{t("amenities.citadine")}</label>
                            </div>
                            <div className={classes.checkBoxContainer}>
                                <Checkbox 
                                    checked={type.berline} 
                                    onChange={() => handleCheckboxChange("type", "berline")} 
                                    className={classes.checkbox} 
                                />
                                <label className={classes.labels}>{t("amenities.berline")}</label>
                            </div>
                            <div className={classes.checkBoxContainer}>
                                <Checkbox 
                                    checked={type.suv} 
                                    onChange={() => handleCheckboxChange("type", "suv")} 
                                    className={classes.checkbox} 
                                />
                                <label className={classes.labels}>{t("amenities.suv")}</label>
                            </div>
                            <div className={classes.checkBoxContainer}>
                                <Checkbox 
                                    checked={type.utilitaire} 
                                    onChange={() => handleCheckboxChange("type", "utilitaire")} 
                                    className={classes.checkbox} 
                                />
                                <label className={classes.labels}>{t("amenities.utilitaire")}</label>
                            </div>
                        </div>

                        {/*<Divider orientation="vertical" flexItem className={classes.divider} />

                        <div>
                            <Typography className={classes.sectionHeader}>{t("home.number-of-rooms")}</Typography>
                            <div className={classes.checkBoxContainer}>
                                <Checkbox 
                                    checked={rooms.oneRoom} 
                                    onChange={() => handleCheckboxChange("rooms", "oneRoom")} 
                                    className={classes.checkbox} 
                                />
                                <label className={classes.labels}>{t("amenities.1bag")}</label>
                            </div>
                            <div className={classes.checkBoxContainer}>
                                <Checkbox 
                                    checked={rooms.twoRooms} 
                                    onChange={() => handleCheckboxChange("rooms", "twoRooms")} 
                                    className={classes.checkbox} 
                                />
                                <label className={classes.labels}>{t("amenities.2bags")}</label>
                            </div>
                            <div className={classes.checkBoxContainer}>
                                <Checkbox 
                                    checked={rooms.threeRooms} 
                                    onChange={() => handleCheckboxChange("rooms", "threeRooms")} 
                                    className={classes.checkbox} 
                                />
                                <label className={classes.labels}>{t("amenities.3bagsAndMore")}</label>
                            </div>
                        </div> */}
                    </div>
                
            </Grid>
        )}

        {searchTypeName === "rstt" && isAdvancedSearchExpanded && (
        <Grid item xs={12} md={8} lg={8} className={classes.gridItem}>
          <div className={classes.mainRow} >

                    <div>
                        <Typography className={classes.sectionHeader}>{t("home.estate-to-rent")}</Typography>                        
                        <div className={classes.checkBoxContainer}>
                            <Checkbox 
                                checked={type.apartmentRent} 
                                onChange={() => handleCheckboxChange("type", "apartmentRent")} 
                                className={classes.checkbox} 
                            />
                            <label className={classes.labels}>{t("amenities.apartment-rent")}</label>
                        </div>
                        <div className={classes.checkBoxContainer}>
                            <Checkbox 
                                checked={type.houseRent} 
                                onChange={() => handleCheckboxChange("type", "houseRent")} 
                                className={classes.checkbox} 
                            />
                            <label className={classes.labels}>{t("amenities.house-rent")}</label>
                        </div>
                        <div className={classes.checkBoxContainer}>
                            <Checkbox 
                                checked={type.officeRent} 
                                onChange={() => handleCheckboxChange("type", "officeRent")} 
                                className={classes.checkbox} 
                            />
                            <label className={classes.labels}>{t("amenities.office-rent")}</label>
                        </div>
                    </div>

                    <Divider orientation="vertical" flexItem className={classes.divider} />

                    <div>
                        <Typography className={classes.sectionHeader}>{t("home.estate-for-sale")}</Typography>
                        <div className={classes.checkBoxContainer}>
                            <Checkbox 
                                checked={type.landSale} 
                                onChange={() => handleCheckboxChange("type", "landSale")} 
                                className={classes.checkbox} 
                            />
                            <label className={classes.labels}>{t("amenities.land-sale")}</label>
                        </div>
                        <div className={classes.checkBoxContainer}>
                            <Checkbox 
                                checked={type.houseSale} 
                                onChange={() => handleCheckboxChange("type", "houseSale")} 
                                className={classes.checkbox} 
                            />
                            <label className={classes.labels}>{t("amenities.house-sale")}</label>
                        </div>
                        <div className={classes.checkBoxContainer}>
                            <Checkbox 
                                checked={type.largeSpaceSale} 
                                onChange={() => handleCheckboxChange("type", "largeSpaceSale")} 
                                className={classes.checkbox} 
                            />
                            <label className={classes.labels}>{t("amenities.large-space-sale")}</label>
                        </div>


                        {/*<div className={classes.checkBoxContainer}>
                            <Checkbox 
                                checked={rooms.oneRoom} 
                                onChange={() => handleCheckboxChange("rooms", "oneRoom")} 
                                className={classes.checkbox} 
                            />
                            <label className={classes.labels}>{t("amenities.1bag")}</label>
                        </div>
                        <div className={classes.checkBoxContainer}>
                            <Checkbox 
                                checked={rooms.twoRooms} 
                                onChange={() => handleCheckboxChange("rooms", "twoRooms")} 
                                className={classes.checkbox} 
                            />
                            <label className={classes.labels}>{t("amenities.2bags")}</label>
                        </div>
                        <div className={classes.checkBoxContainer}>
                            <Checkbox 
                                checked={rooms.threeRooms} 
                                onChange={() => handleCheckboxChange("rooms", "threeRooms")} 
                                className={classes.checkbox} 
                            />
                            <label className={classes.labels}>{t("amenities.3bagsAndMore")}</label>
                        </div>*/}
                    </div>
                </div>
            
        </Grid>
        )}


        {searchTypeName === "trs" && (
        <Grid item xs={12} md={8} lg={8} className={classes.gridItem}>
        <Grid item xs={12} style={{ marginLeft: '28px' }}>
        <RadioGroup
            row
            value={selectedCategory}
            onChange={handleRadioChange}
        >
            <FormControlLabel
                value="restaurants"
                control={
                    <Radio 
                        color="primary"
                        style={{
                            padding: '3px',
                            marginRight: '4px',
                            color: '#890608',
                        }}
                        icon={<RadioButtonUncheckedIcon style={{ fontSize: 20, color: '#890608' }} />}
                        checkedIcon={<RadioButtonCheckedIcon style={{ fontSize: 20, color: '#890608' }} />}
                        />
                }
                label={
                    <span style={{ 
                        fontSize: '12px', 
                        fontWeight: 'bold', 
                        fontFamily: 'Josefin Sans' 
                    }}>
                        {t("amenities.restaurants")}
                    </span>
                }
                style={{ marginRight: '16px' }}
            />
            <FormControlLabel
                value="otherActivities"
                control={
                    <Radio 
                        color="primary"
                        style={{
                            padding: '3px',
                            marginRight: '4px',
                            color: '#890608',
                        }}
                        icon={<RadioButtonUncheckedIcon style={{ fontSize: 20, color: '#890608' }} />}
                        checkedIcon={<RadioButtonCheckedIcon style={{ fontSize: 20, color: '#890608' }} />}
                        />
                }
                label={
                    <span style={{ 
                        fontSize: '12px', 
                        fontWeight: 'bold', 
                        fontFamily: 'Josefin Sans' 
                    }}>
                        {t("amenities.otherActivities")}
                    </span>
                }
            />
        </RadioGroup>
        </Grid>
            {selectedCategory === 'otherActivities' && (
                <Grid item xs={12} md={8} lg={8} className={classes.gridItem}>
                    <div className={classes.mainRow} >
                        <div>
                            <Typography className={classes.sectionHeader}>{t("home.art-de-vivre")}</Typography>   
                            <div className={classes.checkBoxContainer}>
                                <Checkbox 
                                    checked={type.spas} 
                                    onChange={() => handleCheckboxChange("type", "spas")} 
                                    className={classes.checkbox} 
                                />
                                <label className={classes.labels}>{t("amenities.spas")}</label>
                            </div>
                            <div className={classes.checkBoxContainer}>
                                <Checkbox 
                                    checked={type.musees} 
                                    onChange={() => handleCheckboxChange("type", "musees")} 
                                    className={classes.checkbox} 
                                />
                                <label className={classes.labels}>{t("amenities.musees")}</label>
                            </div>
                            <div className={classes.checkBoxContainer}>
                                <Checkbox 
                                    checked={type.nightlife} 
                                    onChange={() => handleCheckboxChange("type", "nightlife")} 
                                    className={classes.checkbox} 
                                />
                                <label className={classes.labels}>{t("amenities.nightlife")}</label>
                            </div>
                        </div>

                        <Divider orientation="vertical" flexItem className={classes.divider} />

                        <div>
                            <Typography className={classes.sectionHeader}>{t("home.decouverte")}</Typography>                            
                            <div className={classes.checkBoxContainer}>
                                <Checkbox 
                                    checked={type.attractions} 
                                    onChange={() => handleCheckboxChange("type", "attractions")} 
                                    className={classes.checkbox} 
                                />
                                <label className={classes.labels}>{t("amenities.attractions")}</label>
                            </div>
                            <div className={classes.checkBoxContainer}>
                                <Checkbox 
                                    checked={type.parcsNaturels} 
                                    onChange={() => handleCheckboxChange("type", "parcsNaturels")} 
                                    className={classes.checkbox} 
                                />
                                <label className={classes.labels}>{t("amenities.parcs-naturels")}</label>
                            </div>                            
                            <div className={classes.checkBoxContainer}>
                                <Checkbox 
                                    checked={type.sitesHistoriques} 
                                    onChange={() => handleCheckboxChange("type", "sitesHistoriques")} 
                                    className={classes.checkbox} 
                                />
                                <label className={classes.labels}>{t("amenities.sites-historiques")}</label>
                            </div>


                            {/*<div className={classes.checkBoxContainer}>
                                <Checkbox 
                                    checked={rooms.oneRoom} 
                                    onChange={() => handleCheckboxChange("rooms", "oneRoom")} 
                                    className={classes.checkbox} 
                                />
                                <label className={classes.labels}>{t("amenities.1bag")}</label>
                            </div>
                            <div className={classes.checkBoxContainer}>
                                <Checkbox 
                                    checked={rooms.twoRooms} 
                                    onChange={() => handleCheckboxChange("rooms", "twoRooms")} 
                                    className={classes.checkbox} 
                                />
                                <label className={classes.labels}>{t("amenities.2bags")}</label>
                            </div>
                            <div className={classes.checkBoxContainer}>
                                <Checkbox 
                                    checked={rooms.threeRooms} 
                                    onChange={() => handleCheckboxChange("rooms", "threeRooms")} 
                                    className={classes.checkbox} 
                                />
                                <label className={classes.labels}>{t("amenities.3bagsAndMore")}</label>
                            </div>*/}
                        </div>
                    </div>
                </Grid>
            )}
            
        </Grid>
        )}

        {/* Search Button */}
        <Grid item xs={12} md={4} lg={3} className={classes.buttonContainer}>
          <IconButton onClick={handleSearch} className={classes.searchButton}>
            <SearchIcon className={classes.searchIcon} />
            {t("label.research")}
          </IconButton>
        </Grid>
      </Grid>
    </form>
    <div>
        {errorMessages && (
            <Dialog
                open={openError}
                onClose={handleCloseError}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                {/* <DialogTitle id="alert-dialog-title">{t("label.error")}</DialogTitle> */}
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {errorMessages}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseError} color="primary">
                        {t("label.ok")}
                    </Button>
                </DialogActions>
            </Dialog>
        )}
    </div>
    </>

  );
};
